const PROFILE_IMAGE_BASE_URL = 'https://assets.banjihagames.com/seoul2033editor/public/profile';

const profileImageIdLists = [
  'default',
  '11',
  '111',
  '112',
  '113',
  '114',
  '121',
  '125',
  '150',
  '151',
  '178',
  '180',
  '2',
  '208',
  '211',
  '228',
  '244',
  '264',
  // '270',
  '271',
  '29',
  '295',
  '43',
  '47',
  '5',
  '51',
  '62',
  '71',
  '75',
  '80',
  '85',
];

const profileImageList = profileImageIdLists.reduce((acc, id) => {
  acc.push({
    id,
    imageURL: `${PROFILE_IMAGE_BASE_URL}/${id}.png`,
  });

  return acc;
}, []);

export { PROFILE_IMAGE_BASE_URL, profileImageList };
